import { mapGetters } from 'vuex';

export default {
  props: {
    video: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters('player-profile', [
      'selectedVideos',
    ]),

    selected() {
      return this.selectedVideos.filter(video => video.id === this.video.id)
        .length > 0;
    },
  },
  methods: {
    changeStatus(status) {
      this.$emit(status, this.video);
    },
  },
};
